import { useLocation, useNavigate } from "react-router-dom";
import { Play, Mail, Film, Clapperboard } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { label: "Raw Footage", path: "/raw-footage", icon: Film },
    { label: "Short Clips", path: "/clips", icon: Clapperboard },
  ];

  return (
    <header className="glass-header sticky top-0 z-50 w-full" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        {/* Logo */}
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => navigate("/raw-footage")}
          data-testid="header-logo"
        >
          <Play className="w-6 h-6 text-[#FF5A00] fill-[#FF5A00]" />
          <span className="text-xl font-bold tracking-tight text-[#0A1128]" style={{ fontFamily: 'Outfit' }}>
            HiFy
          </span>
        </div>

        {/* Nav Tabs */}
        <nav className="flex items-center gap-1" data-testid="nav-tabs">
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.path;
            const Icon = tab.icon;
            return (
              <button
                key={tab.path}
                onClick={() => navigate(tab.path)}
                data-testid={`nav-tab-${tab.path.slice(1)}`}
                className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg transition-all ${
                  isActive
                    ? "text-[#FF5A00] bg-[#FF5A00]/10"
                    : "text-[#0A1128]/60 hover:text-[#0A1128] hover:bg-[#0A1128]/5"
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </nav>

        {/* Contact */}
        <a
          href="mailto:harsh.shah@hify.club"
          data-testid="header-contact-btn"
          className="inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] text-white text-sm font-bold px-4 py-2 rounded-lg shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all tracking-wide"
        >
          <Mail className="w-4 h-4" />
          <span className="hidden sm:inline">Contact Us</span>
        </a>
      </div>
    </header>
  );
}
